import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import style from './Note.scss'

function Note(props) {
  const { children, className, show, hide, error } = props

  if ('show' in props) {
    if (!!show === false) {
      return null
    }
  }

  if ('hide' in props) {
    if (!!hide === true) {
      return null
    }
  }

  const componentClass = cx(style.note, {
    [style.error]: error,
    [className]: className,
  })

  return <div className={componentClass}>{children}</div>
}

Note.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  error: PropTypes.bool,
  show: PropTypes.bool,
  hide: PropTypes.bool,
}

export default Note



// WEBPACK FOOTER //
// ./src/components/Common/Note.js